
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Check, X, BadgeCheck, BadgeX } from "lucide-react";
import type { NursingHomeClaim } from "@/types/admin";

/** Primary label for table: legal name from claim form, else account profile name. */
export function claimTableDisplayName(claim: NursingHomeClaim): string {
  const legal = claim.verification_documents?.legalName;
  if (typeof legal === "string" && legal.trim()) return legal.trim();
  const fn = claim.user?.user_metadata?.first_name ?? "";
  const ln = claim.user?.user_metadata?.last_name ?? "";
  const account = `${fn} ${ln}`.trim();
  return account || "—";
}

/** Subline: work email from claim form, else login email. */
export function claimTableSecondaryLine(claim: NursingHomeClaim): string {
  const work = claim.verification_documents?.email;
  if (typeof work === "string" && work.trim()) return work.trim();
  return claim.user?.email?.trim() || "—";
}

/**
 * Returns a badge component based on status.
 * Only uses allowed Lucide icons.
 */
export function getStatusBadge(status: string) {
  if (status?.startsWith("pending")) {
    return (
      <Badge variant="outline" className="bg-amber-50 text-amber-700 border-amber-200">
        <BadgeCheck className="w-3 h-3 mr-1" />
        Pending
      </Badge>
    );
  }
  switch (status) {
    case "approved":
      return (
        <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
          <Check className="w-3 h-3 mr-1" />
          Approved
        </Badge>
      );
    case "rejected":
      return (
        <Badge variant="outline" className="bg-red-50 text-red-700 border-red-200">
          <X className="w-3 h-3 mr-1" />
          Rejected
        </Badge>
      );
    case "needs_info":
      return (
        <Badge variant="outline" className="bg-orange-50 text-orange-800 border-orange-200">
          <BadgeCheck className="w-3 h-3 mr-1" />
          Needs info
        </Badge>
      );
    default:
      return <Badge>{status}</Badge>;
  }
}
